<template>
  <div class="arrow mt-2 pa-2" style="border: 1px solid #eee; border-radius: 5px">
    <div class="mr-2" style="display: inline-block" v-if="linenotifylist.length > 0">
      <template v-for="(admin, index) in linenotifylist">
        <v-avatar
          :key="admin.id + index"
          v-if="index < 3"
          size="30"
          :style="{ 'margin-left': index != 0 ? '-10px' : '0px' }"
        >
          <v-img :src="`https://graph.facebook.com/${admin.adminid}/picture?type=square&SameSite=None`"></v-img>
        </v-avatar>
      </template>

      <v-avatar color="grey" size="30" v-if="linenotifylist.length > 3" style="margin-left: -10px">
        <span class="white--text">+{{ linenotifylist.length - 3 }}</span>
      </v-avatar>
    </div>

    <a class="caption" href="javascript:void(0);" @click="onEdit"> {{$t('Notification Setting')}} </a>

    <v-dialog v-model="show" persistent max-width="600">
      <v-card>
        <v-card-text>
          <!-- Select line notify -->
          <div>{{$t('Select Line Account')}}</div>
          <v-combobox
            style="z-index: 0;"
            v-model="linenotifylist"
            :items="$store.state.linenotifylist"
            :item-text="'name'"
            :item-value="'id'"
            multiple
            chips
            outline
            single-line
          >
            <template v-slot:selection="data">
              <v-chip
                :key="JSON.stringify(data.item)"
                :selected="data.selected"
                :disabled="data.disabled"
                class="v-chip--select-multi"
                @input="data.parent.selectItem(data.item.adminid)"
              >
                <v-avatar>
                  <v-img
                    :src="`https://graph.facebook.com/${data.item.adminid}/picture?type=square&SameSite=None`"
                  ></v-img>
                </v-avatar>
                {{ data.item.name }}
              </v-chip>
            </template>
          </v-combobox>
          <div class="text-xs-center">
            <v-btn color="grey" outline @click="onCancel">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
export default {
  props: ['value'],
  data() {
    return {
      show: false,
      list: '',
    }
  },
  computed: {
    linenotifylist: {
      get() {
        try {
          if (this.list) {
            return this.$store.state.linenotifylist.filter((el) => {
              return this.list.includes(el.id)
            })
          }
        } catch (error) {
          console.log(error)
        }
        return []
      },
      set(val) {
        this.list = val
          .map((el) => {
            return el.id
          })
          .join(',')
      },
    },
  },
  mounted() {
    this.list = this.value
  },
  methods: {
    onEdit() {
      this.show = true
      this.cached_list = cloneDeep(this.list)
    },
    onCancel() {
      this.show = false
      this.list = cloneDeep(this.cached_list)
    },
    onSave() {
      this.show = false
      this.$emit('onSave', this.list)
      this.$emit('input', this.list)
      this.cached_list = cloneDeep(this.list)
    },
  },
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/billing/SelectSpecificLinenotify.vue